"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXACT_MATCH_PRICE_STYLES = exports.ADD_TO_CART_BUTTON_STYLE = void 0;
const EXACT_MATCH_PRICE_STYLES = exports.EXACT_MATCH_PRICE_STYLES = {
  mobile: {
    mainPriceStyle: {
      fontWeight: 850,
      fontSize: '18px'
    },
    strikethroughPriceStyle: {
      fontWeight: 565,
      fontSize: '14px'
    },
    disclaimerStyle: {
      fontWeight: 565,
      fontSize: '12px'
    }
  },
  desktop: {
    mainPriceStyle: {
      fontWeight: 850,
      fontSize: '30px'
    },
    strikethroughPriceStyle: {
      fontWeight: 565,
      fontSize: '22px'
    },
    disclaimerStyle: {
      fontWeight: 565,
      fontSize: '12px'
    }
  }
};
const ADD_TO_CART_BUTTON_STYLE = exports.ADD_TO_CART_BUTTON_STYLE = {
  borderRadius: 'border-radius-4'
};